/*
Usage :

<text-field
   v-model="email"
   v-bind:isError="formErrors.email"
   v-bind:title="formErrorsMessages.email"
   />

<div class="error" v-if="formErrorsMessages.all">
  {{formErrorsMessages.all}}
</div>

import { handleFormErrorsMixin } from '@/mixins/handle_form_errors_mixin';

export default {
    [...]
    mixins: [handleFormErrorsMixin],
    [...]
    methods: {
        save() {
            [...]
            this.resetErrorFields();
            apiClient
                .groupUpdate(group)
                .then(response => {
                    this.waitSaving = false;
                    [...]
                })
                .catch(error => {
                    this.waitSaving = false;
                    this.handleFormErrors(error);
                });
        },
    },
};

*/
import vmodal from 'vue-js-modal';
import _ from 'lodash';

export var handleFormErrorsMixin = {
    components: {
        vmodal,
    },
    data() {
        return {
            formErrors: {},
            formErrorsMessages: {},
            waitSaving: false,
        };
    },
    methods: {
        template: function(text) {
            return `
<div class="modal-content">
   <div class="modal-content-inside">
      <font-awesome-icon
         icon="exclamation-circle"
         class="help-icon"
         />
      <h1>Erreur</h1>
      <p>${text}</p>
   </div>
   <button
      type="button"
      class="button float-right"
      v-on:click="$emit('close')"
    >
      <font-awesome-icon icon="check-circle" />
      OK
   </button>
</div>
                `;
        },
        showModal: function(text) {
            this.$modal.show(
                {
                    template: this.template(text),
                },
                {
                    transition: 'nice-modal-fade',
                    minWidth: 200,
                    delay: 100,
                    scrollable: true,
                    height: 380,
                    adaptive: true,
                    resizable: true,
                },
            );
        },
        showError: function(allMessage) {
            this.showModal('Le formulaire comporte des erreurs, merci de les corriger avant d\'enregistrer vos modifications.<br>' + allMessage);
        },
        showErrorForbidden: function() {
            this.showModal('Vous n\'avez pas la permission d\'effectuer cette opération.');
        },
        showErrorNotFound: function() {
            this.showModal('Enregistrement non trouvé.');
        },
        showErrorServer: function() {
            this.showModal('Erreur serveur. Réessayez plus tard et contactez votre administrateur si le problème persiste.');
        },
        resetErrorFields: function() {
            this.formErrors = {};
            this.formErrorsMessages = {};
        },
        handleFormErrors: function(error) {
            if (error.response.status === 400) {
                var allMessage = '';
                for (let field in error.response.data) {
                    this.formErrors[this.transformToCamelCase(field)] = true;
                    this.formErrors[field] = true;
                    this.formErrorsMessages[field] = error.response.data[field][0];
                    this.formErrorsMessages[this.transformToCamelCase(field)] = error.response.data[field][0];
                    if (field === '__all__') {
                        allMessage = error.response.data[field][0];
                    }
                }
                this.showError(allMessage);
                return;
            }
            if (error.response.status === 403) {
                this.showErrorForbidden();
                return;
            }
            if (error.response.status === 404) {
                this.showErrorNotFound();
                return;
            }
            if (error.response.status === 500 || error.response.status === 502) {
                this.showErrorServer();
            }
        },
        transformToCamelCase: function(text) {
            return _.camelCase(text);
        },
    },
};
